export default __webpack_public_path__ + "static/media/carbon_logo.9ff6bc5c.svg";